import { documents } from "./documents/documents";
import { documentCategories } from "./documentCategories/documentCategories";

export const documentService = {
  documents,
  documentCategories,
};
